import React from "react";

// Official PropertyConnect logo — the supplied light-blue asset, used exactly as provided
// (no crop/recolor; aspect 3:1 preserved). `plate` = dark-surface styling (subtle edge + shadow).
export const BRAND_LOGO = "/brand/propertyconnect-logo-v2.webp";

export function BrandLogo({ plate = false, className = "h-12", testid = "brand-logo" }) {
  return (
    <img src={BRAND_LOGO} alt="PropertyConnect" draggable={false} data-testid={testid}
      width={2000} height={667}
      className={`${className} aspect-[3/1] w-auto max-w-none shrink-0 select-none rounded-[10px] object-contain ${plate ? "shadow-[0_2px_10px_rgba(0,0,0,0.25)] ring-1 ring-white/20" : "ring-1 ring-slate-900/5"}`} />
  );
}

export default BrandLogo;
